import React, { useState } from "react";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { makeStyles } from "@material-ui/core/styles";
import prescriptionIcon from "../../images/prescription.svg";
import PrenscriptionDialog from "../prescription/PrenscriptionDialog";
import useUserState from "../hooks/useUserState";
import Axios from "axios";
import useBDocTranslator from "../hooks/useBDocTranslator";
import swal from "sweetalert";
import { useParams } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { NO_APPOINTMENT } from "../providers/SelectAppt";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    fontFamily: theme.typography.fontFamily,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    boxShadow: theme.shadows[8],
    padding: theme.spacing(3, 4),
    width: "92%",
    maxWidth: 760,
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2),
    },
    maxHeight: "90vh",
    overflowY: "auto",
    position: "relative",
  },
  header: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    "& img": {
      width: 32,
      height: 32,
    },
    "& h3": {
      margin: 0,
      fontFamily: theme.typography.fontFamily,
      fontSize: "1.125rem",
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
  },
  headerText: {
    flex: 1,
  },
  subtitle: {
    margin: 0,
    fontSize: "0.82rem",
    color: theme.palette.text.secondary,
  },
  loadingOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
}));

export default function PrescriptionModalForm(props) {
  const classes = useStyles();
  const [notes, setNotes] = useState(""); // this is the state for prescription
  const [responseMessage, setResponseMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const userLocalState = useUserState();
  const { t } = useBDocTranslator();
  const [dispenseTo, setDispenseTo] = useState(null);
  const [pharmacy, setPharmacy] = useState(null);
  const [apptSelected, setApptSelected] = useState(NO_APPOINTMENT);
  let { id } = useParams();

  const handleNotes = (value) => {
    setNotes(value);
  };

  // Deja el formulario limpio para la siguiente receta.
  const resetForm = () => {
    setNotes("");
    setDispenseTo(null);
    setPharmacy(null);
    setApptSelected(NO_APPOINTMENT);
    setResponseMessage("");
  };

  const handleClose = () => {
    if (isLoading) return;
    resetForm();
    props.handleClose();
  };

  //Method for Save the prescription
  const handlePrescriptionSave = () => {
    setIsLoading(true);
    Axios.post(
      `${process.env.REACT_APP_API_URL_BASE}/prenscriptions/create${
        apptSelected === NO_APPOINTMENT || !apptSelected?.id ? "/only" : ""
      }`,
      {
        patient_directions: notes,
        created_by_userId: userLocalState[0].user.id,
        appointment_id: apptSelected?.id || null,
        patient_id: props.patientId,
        dispense_from: new Date(),
        dispense_to: dispenseTo,
        pharmacy_id:
          pharmacy !== null && pharmacy !== "select" ? pharmacy : null,
        pharmacyReferalsFlag: pharmacy !== null && pharmacy !== "select",
      },
      {
        headers: { Authorization: "Bearer " + userLocalState[0].jwt },
      }
    )
      .then((response) => {
        resetForm();
        swal("Exito", t(response.data.message), "success");
        props.handleClose();
        if (props.recall) props.recall(id);
      })
      .catch((error) => {
        console.log(error);
        setResponseMessage(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={props.open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.open}>
          {
            <div
              className={classes.paper}
              role="dialog"
              aria-labelledby="prescription-modal-title"
            >
              {isLoading && (
                <div className={classes.loadingOverlay}>
                  <CircularProgress />
                </div>
              )}
              <div className={classes.header}>
                <img src={prescriptionIcon} alt="" />
                <div className={classes.headerText}>
                  <h3 id="prescription-modal-title">
                    {t("Create Prescription")}
                  </h3>
                  <p className={classes.subtitle}>
                    {t("Fields marked as optional can be left empty")}
                  </p>
                </div>
                <IconButton
                  aria-label={t("Close")}
                  onClick={handleClose}
                  disabled={isLoading}
                  size="small"
                >
                  <CloseIcon />
                </IconButton>
              </div>
              {/* Form */}
              <div>
                <PrenscriptionDialog
                  handleNotes={handleNotes}
                  prescriptionValue={notes}
                  handleSave={handlePrescriptionSave}
                  handleCancel={handleClose}
                  patientId={props.patientId}
                  responseMessage={responseMessage}
                  setDispenseTo={setDispenseTo}
                  dispenseTo={dispenseTo}
                  setPharmacy={setPharmacy}
                  pharmacy={pharmacy}
                  setApptSelected={setApptSelected}
                  apptSelected={apptSelected}
                  isLoading={isLoading}
                />
              </div>
            </div>
          }
        </Fade>
      </Modal>
    </div>
  );
}
